// Shubi Shubi enhancements. Everything here upgrades markup that already works without JavaScript.

/** Game-day bag check: count packed items, fill the meter, announce progress. */
function initPackLists(root = document) {
  for (const pack of root.querySelectorAll('[data-ss-pack]:not([data-ss-ready])')) {
    pack.dataset.ssReady = 'true';
    const items = [...pack.querySelectorAll('[data-ss-pack-item]')];
    const pips = [...pack.querySelectorAll('.ss-pack__meter i')];
    const status = pack.querySelector('[data-ss-pack-status]');
    if (!items.length || !status) continue;

    const progress = status.dataset.progress || '[count] of [total] packed';
    const done = status.dataset.done || '';

    const update = () => {
      const count = items.filter((item) => item.checked).length;
      pips.forEach((pip, index) => pip.classList.toggle('is-on', index < count));
      const finished = count === items.length;
      pack.toggleAttribute('data-complete', finished);
      status.textContent =
        finished && done ? done : progress.replace('[count]', String(count)).replace('[total]', String(items.length));
    };

    pack.addEventListener('change', update);
    update();
  }
}

/** Anatomy: pointing at a legend item lights up its hotspot on the product. */
function initAnatomy(root = document) {
  for (const anatomy of root.querySelectorAll('[data-ss-anatomy]:not([data-ss-ready])')) {
    anatomy.dataset.ssReady = 'true';
    const setActive = (key) => {
      for (const el of anatomy.querySelectorAll('[data-ss-hotspot], [data-ss-legend]')) {
        const match = el.dataset.ssHotspot === key || el.dataset.ssLegend === key;
        el.classList.toggle('is-active', key !== null && match);
      }
    };
    for (const item of anatomy.querySelectorAll('[data-ss-legend]')) {
      item.addEventListener('pointerenter', () => setActive(item.dataset.ssLegend));
      item.addEventListener('pointerleave', () => setActive(null));
    }
  }
}

/** Panels: add to cart in place and hand the result to the theme's cart drawer. */
async function addToCart(form) {
  const button = form.querySelector('[data-ss-atc-button]');
  const status = form.querySelector('[data-ss-atc-status]');
  const routes = typeof Theme !== 'undefined' ? Theme.routes : null;
  if (!routes) return false;

  let CartLinesUpdateEvent = null;
  try {
    ({ CartLinesUpdateEvent } = await import('@shopify/events'));
  } catch (error) {
    return false;
  }

  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((element) => element.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  button?.setAttribute('aria-disabled', 'true');
  try {
    const response = await fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData,
    });
    const result = await response.json();
    const cart = await fetch(`${routes.cart_url}.json`).then((res) => res.json());
    const didError = Boolean(result.status);

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'ss-product-panel',
        sourceId: form.id,
        itemCount: 1,
        productId: form.dataset.productId,
        sections: result.sections,
        didError,
      },
    });

    if (status) status.textContent = didError ? result.description || result.message || '' : '';
  } catch (error) {
    deferred.reject(error);
    form.submit();
  } finally {
    button?.removeAttribute('aria-disabled');
  }
  return true;
}

function initPanels(root = document) {
  for (const form of root.querySelectorAll('form[data-ss-atc]:not([data-ss-ready])')) {
    form.dataset.ssReady = 'true';
    form.addEventListener('submit', async (event) => {
      if (form.dataset.ssBusy) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      form.dataset.ssBusy = 'true';
      const handled = await addToCart(form);
      delete form.dataset.ssBusy;
      if (!handled) form.submit();
    });
  }
}

function init(root = document) {
  initPackLists(root);
  initAnatomy(root);
  initPanels(root);
}

init();

// Re-run after the theme editor re-renders a section.
document.addEventListener('shopify:section:load', (event) => init(event.target));
